import EnvBase from '@/env'
import svrapi from '@/svrapi'
import { MessageBox } from 'element-ui'
import Cookies from 'js-cookie'
import SparkMD5 from 'spark-md5'

const PT = EnvBase.PT

export function parseTime(time, cFormat, isUTC = false) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (/^[0-9]{0,}$/.test(time + '')) time = parseInt(time) * 1000
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      if (key === 'a') return ['日', '一', '二', '三', '四', '五', '六'][value]
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
}

export function formatTime(time, option) {
    time = +time * 1000
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) { // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
    }
}

/**
 * 设置路由查询参数
 * @param param {Object} 要设置的参数对象
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
export function setRouteQuery(param, method = 'push') {
  this.$router[method](`${this.$route.path}?${toFormData(param)}`)
}

/**
 * 获取下载地址(新)
 * @param name {string} api名称
 * @param params {object} 参数
 * @param auth {boolean} 是否需要鉴权参数
 * @returns {string} 完整的下载地址
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
export function createDownloadUrl(name, params, auth = true) {
  let query = '?'
  if (auth) {
    const token = Cookies.get(PT.qnlogin.localSessName)
    query += `api_local_sess=${token}&api_usagespace=${PT.config.platformUsagespace}&`
  }
  if (Object.keys(params).length) {
    query += `${toFormData(params)}`
  }
  return `${PT.config.apiBaseUrl}${svrapi[name]}${query}`
}

/**
 * 验证表单
 * @param name
 * @returns {Promise<any>}
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
export function validate(name) {
  return new Promise((resolve, reject) => {
    this.$refs[name].validate(valid => {
      if (valid) {
        resolve()
      } else {
        reject()
      }
    })
  })
}

/**
 * 重置表单
 * @param name
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
export function resetFields(name) {
  this.$refs[name].resetFields()
}

/**
 * 对部分表单字段进行校验的方法
 * @param prop 表单字段
 * 注意，调用时必须通过call方法或者apply方法调用，否则this指向会报错
 */
export function validateField(prop) {
  return new Promise((resolve, reject) => {
    this.$refs[name].validateField(prop, err => {
      if (err) {
        resolve(err)
      } else {
        reject(err)
      }
    })
  })
}

/**
 * 过滤掉空属性
 * @param obj {object} 需要过滤的对象
 * @returns {object}
 */
export function filterEmptyProperty(obj) {
  const params = {}
  Object.keys(obj).forEach(key => {
    if (obj[key] !== null && obj[key] !== undefined && obj[key] !== '') {
      params[key] = obj[key]
    }
  })
  return params
}

/**
 * 代理http请求，返回promise对象
 * @param name {string} api名称
 * @param params {object} api参数
 * @returns Promise
 */
export function agencyQnbarRequest(name, params = {}) {
  return new Promise((resolve, reject) => {
    PT.apiClient.query(svrapi[name], params, (res) => {
      if (res.code === 0) {
        resolve(res)
      } else {
        reject(res)
        if(svrapi[name] !== "warehouse/mix/psn/check") {
          MessageBox.alert(res.msg, '提示')
        }
        // MessageBox.alert(res.msg, '提示')
      }
    })
  })
}

/**
 * 将参数对象转化为键值对的字符串
 * @param data {object} 参数对象
 * @returns {string}
 */
export function toFormData(data) {
  let res = ''
  Object.keys(data).forEach(key => {
    res += encodeURIComponent(key) + '=' + encodeURIComponent(data[key]) + '&'
  })
  return res.slice(0, -1)
}

/**
 * 深克隆数据
 * @param data {object} 参数对象
 * @returns {Object}
 */
export function deepCopy(data = {}) {
  return JSON.parse(JSON.stringify(data))
}

/**
 * 限制操作频率
 * @param      { Function }    cb      定时器回调函数
 * @param      { number= }     time    时间间隔
 * @returns    {Function}
 */
export function limitOperationHz(cb, time = 1000) {
  let interval = null
  return function() {
    if (interval) {
      // console.log('清除定时器')
      clearInterval(interval)
    }
    return new Promise((resolve, reject) => {
      interval = setTimeout(() => {
        // console.log('执行回调')
        resolve(cb.apply(this, arguments))
      }, time)
    })
  }
}

export function toMulFormData(data) {
  const formData = new FormData()
  Object.keys(data).forEach(key => {
    formData.append(key, data[key])
  })
  return formData
}

//计算视频md5的方法
export function calculateMd5ByChunkSize(file, chunkSize = 1024 * 1024) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    const chunks = Math.ceil(file.size / chunkSize)
    let currentChunk = 0
    const spark = new SparkMD5.ArrayBuffer()

    //读取完成时触发事件
    fileReader.onload = function (e) {
      spark.append(e.target.result)
      currentChunk++
      if (currentChunk < chunks) {
        readChunk()
      }
      else {
        resolve(spark.end())
      }
    }

    fileReader.onerror = function(e) {
      reject(e)
    }

    function readChunk() {
      const start = currentChunk * chunkSize
      const end = start + chunkSize >= file.size ? file.size : start + chunkSize
      fileReader.readAsArrayBuffer(file.slice(start, end))
    }

    readChunk()
  })
}

// 计算文件的MD5
export function calculateMD5File_2(file,chunkSize) {
	return new Promise((resolve, reject) => {
					let blobSlice = File.prototype.slice || File.prototype.mozSlice || File.prototype.webkitSlice;
					let chunks = Math.ceil(file.size / chunkSize);
					let currentChunk = 0;
					let spark = new SparkMD5.ArrayBuffer();
					let fileReader = new FileReader();
					fileReader.onload = function(e) {
						spark.append(e.target.result); 
						currentChunk++;
						if (currentChunk < chunks) {
							loadNext();
						} else {
							let md5 = spark.end();
							resolve(md5);
						}
					};
					fileReader.onerror = function(e) {
						reject(e);
					};
					function loadNext() {
						let start = currentChunk * chunkSize;
						let end = start + chunkSize;
						if (end > file.size){
							end = file.size;
						}
						fileReader.readAsArrayBuffer(blobSlice.call(file, start, end));
					}
					loadNext();
			});
}


/**
 * 返回有变动的属性
 * @param oldVal {Object} 旧的对象
 * @param newVal {Object} 新对象
 * @param filter {Array=} 例外的属性不检测
 * @returns {(boolean|Object)} 变动属性组成的对象，如果属性无变动则返回false
 */
export function getChangeProps(oldVal, newVal, filter = []) {
  if (oldVal === newVal) return {}
  const keys = Object.keys(oldVal)
  const changeProps = {}
  keys.forEach(key => {
    if (filter.includes(key)) return
    if (oldVal[key] !== newVal[key]) {
      changeProps[key] = newVal[key]
    }
  })
  if (!Object.keys(changeProps).length) return false
  return changeProps
}

// 防抖
export function debounce(fn, delay) {
  let timer = null;
  return function () {
    if (timer) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      fn.apply(this, arguments)
    }, delay)
  }
}

/**
 * 添加了自动转参数
 * @returns Promise
 */
export function agencyQnbarRequest2() {
  try {
    arguments[1] = humpToUnderline(arguments[1])
  } catch (e) { }
  return agencyQnbarRequest.apply(null, arguments)
}

// 获取图片分辨率
export function getImageInfo(url) {
  return new Promise((resolve) => {
    const image = new Image();
    let w, h;
    image.src = url;
    if (!image.complete) {
      image.onload = function () {
        w = image.width;
        h = image.height;
        image.onload = null;
        resolve({
          width: w,
          height: h,
        });
      };
      return
    }
    w = image.width;
    h = image.height;
    resolve({
      width: w,
      height: h,
    });
  });
}


// WEBPACK FOOTER //
// ./src/utils/index.js